import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAnyTotalReport,
  getCrsReportOfficesClear,
  getCrsReportTrendOfSingle,
  getLpTableDetail,
  getLpTrendClearSingle,
  getLpTrendSingle,
  getSavedFilterDataById,
  getSavedFilterDataResponseClearById,
} from "../../../redux/reports/actions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
  getLpTable,
  getLpTableClear,
  getLpRea,
  getLpReaClear,
  getLpManagers,
  getLpManagersClear,
  getLpOffices,
  getLpOfficesClear,
  getLpTrend,
  getLpTrendClear,
  getLpStats,
  getLpStatsClear,
} from "../../../redux/reports/actions";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableSectionComp from "../ReportsComponents/ReportTableSectionComp";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import ManagerReportSec from "../ReportsComponents/ManagerReportSec";
import OfficeSection from "../ReportsComponents/OfficeSection";
import Loader from "../../../components/Loader/Loader";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import moment from "moment";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import ReportGraphComponent from "../layout/ReportGraphComponent";
import REACardAreaSection from "../layout/REACardAreaSection";
import ManagerReportCrs from "../New Progress Report/ManagerReportCrs";
import OfficesReportSection from "../New Progress Report/OfficesReportSection";
import ProgressReportTableComponent from "../progressReport/ProgressReportTableComponent";
import { isAndroid, isIOS } from "react-device-detect";
import axios from "axios";
import API_LIST from "../../../utils/apiList";
import ConfirmModal from "../../modal/ConfirmModal";

const LearningPathReportHomeSection = (props) => {

  const { isMobile } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isCompliance = params.get("isCompliance");

  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");

  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Learning Points" },
    { id: 2, value: "Progress" },
    { id: 3, value: "Learning Hours" },
  ];
  const d = new Date();
  let year = d.getFullYear();

  const rea_ids = [];
  const manager_ids = [];
  const office_ids = [];
  const lp_ids = [];
  let PageSize = 20;

  const authBroker = useSelector(state => state.auth.authBroker)
  const authIframeBroker = useSelector(state => state.auth.authIframeBroker)
  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById
  );
  const lpTableRes = useSelector((state) => state.report?.lpTable);
  const lpReaResponse = useSelector((state) => state.report?.lpReaRes);
  const lpManagersRes = useSelector((state) => state.report?.lpManagers);
  const lpTrendRes = useSelector((state) => state.report?.lpTrend);
  const lpTrendResSingle = useSelector((state) => state.report?.lpTrendSingle);
  const lpStatsRes = useSelector((state) => state.report?.lpStats);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  // const profileReportRes = useSelector((state) => state.report?.profileReport);
  // const anyTotalReportRes = useSelector(
  //   (state) => state.report?.anyTotalReport
  // );
  // const crsCompletionTrendRes = useSelector(
  //   (state) => state.report.complianceCompletionTrend
  // );
  const [confirmModal, setConfirmModal] = useState(false)
  const [trendYear, setTrendYear] = useState(year);
  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");
  const [overCrsGraphData, setOverCrsGraphData] = useState([]);
  const [crsCompltTrendData, setCrsCompltTrendData] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [realEstateAgent, setRealEstateAgent] = useState([]);
  const [overAllManagersData, setOverAllManagersData] = useState([]);
  const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
  const [overAllLearningHours, setOverAllLearningHours] = useState([]);
  const [OverAllStatsData, setOverAllStatsData] = useState([]);
  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(true);
  const [isLoaded, setIsLoaded] = useState(true);
  const [limitData, setLimitData] = useState();
  const [imgLoader, setImgLoader] = useState(true);
  const [loadSpining, setLoadSpining] = useState(true);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userStatusFilter, setUserStatusFilter] = useState(1)
  // console.log("Thhh", overAllDataRes?.payload?.payload?.stats);
  const [statusFilterData] = useState([
    "completed",
    "in-progress",
    "not-started",
    "overdue",
  ]);
  const [profileReports, setProfileReports] = useState([]);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);
  const [totalRea, setTotalRea] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(1);
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const [reaList, setReaList] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [localFilters, setLocalFilters] = useState({})
  const [pageNum, setPageNum] = useState(0)
  const [pageSize, setPageSize] = useState(50);
  const [userDetails, setUserDetails] = useState({});
  const [showFilters, setShowFilters] = useState({
    reportingPeriod: true,
    provider: false,
    offices: true,
    reportingTo: true,
    learningContentType: false,
    learningContent: true,
    agents: true,
    status: true,
    role: true,
    brokerages: false,
    agentStatus: true,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: false,
      rea: true,
    },
    assignmentFrom: true
  });

  //new design changes
  const [isExpand, setIsExpand] = useState(false);
  const [check, setCheck] = useState(isCompliance === "0" ? false : true);
  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedBrokerageList: [],
    selectedManagerCoachList: [],
    check: isCompliance === "0" ? false : true,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedStatus: ["completed", "in-progress", "overdue", "not-started"],
    selectedAssignment: ["self","manager","broker_admin","api"],
    selectedRole: ["realtor", "manager", "guest", "all"],
    selectedAgentStatus: [1],
    clickedApply: false,
  });

  const [initSelectedFilters, setInitSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    check: isCompliance === "0" ? false : true,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedStatus: ["completed", "in-progress", "overdue", "not-started"],
    selectedAssignment: ["self","manager","broker_admin","api"],
    selectedRole: ["realtor", "manager", "guest", "all"],
    selectedAgentStatus: [1],
    clickedApply: false,
  });
  const [loaderChart, setLoaderChart] = useState(true);
  const [seriesOfAll, setSeriesOfAll] = useState([]);
  const [legendOfAll, setLegendOfAll] = useState([]);
  const [trendFilterCourses, setTrendFilterCourses] = useState([]);
  const [seriesOfSingle, setSeriesOfSingle] = useState([]);
  const [legendOfSingle, setLegendOfSingle] = useState([]);
  const [trendLoaderChart, setTrendLoaderChart] = useState(false);
  const [crsCompltTrendValuesOfSingle, setCrsCompltTrendValuesOfSingle] =
    useState([]);
  const [filterYearDataOfSingle, setFilterYearDataOfSingle] = useState([]);
  const [totalManagers, setTotalManagers] = useState();
  const [totalOffices, setTotalOffices] = useState([]);
  const [overAllOfficesData, setOverAllOfficesData] = useState([]);
  const [loadSpinner, setLoadSpinner] = useState(false);
  const lpOfficesRes = useSelector((state) => state?.report?.lpOffices);
  const [counterForOffice, setCounterForOffice] = useState(1);
  const [counterForMng, setCounterForMng] = useState(1);
  const [progressSort, setProgressSort] = useState("asc");
  const [searchInput, setSearchInput] = useState('')
  const [officeLabel, setOfficeLabel] = useState('')

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (!_.isEmpty(authBroker.payload?.user?.config) && 
      authBroker.payload?.user?.config.office_name) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name)
      } else {
        setOfficeLabel('Office Name')
      }
    }
  }, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (!_.isEmpty(authIframeBroker.payload?.user?.config) && authIframeBroker.payload?.user?.config.office_name) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name)
      } else {
        setOfficeLabel('Office Name')
      }
    }
  }, [authIframeBroker])

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === 'success') {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: true,
              provider: false,
              offices: true,
              reportingTo: false,
              learningContentType: false,
              learningContent: true,
              agents: true,
              status: true,
              role: false,
              agentStatus: false,
              brokerages: true,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: false,
                rea: true,
              },
              assignmentFrom: true
            })
          }
          // setIsExpand(true)
        }
      }
    }
  }, [authBroker])

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: true,
            provider: false,
            offices: true,
            reportingTo: false,
            learningContentType: false,
            learningContent: true,
            agents: true,
            status: true,
            role: false,
            agentStatus: false,
            brokerages: true,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: false,
              rea: true,
            },
            assignmentFrom: true
          })
          // setIsExpand(true)
        }
      }
    }
  }, [authIframeBroker])

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
    };
  }, [filterId]);

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0]
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    if (savedFiltersDataById?.filter_content) {
      const rea_ids = [];
      const manager_ids = [];
      const office_ids = [];
      const lp_ids = [];
      let userStatus = 1;

      let selectedFiltersById = savedFiltersDataById?.filter_content;

      selectedFiltersById?.selectedOfficeList.forEach(function (obj) {
        office_ids.push(obj.office_id);
      });
      selectedFiltersById?.selectedTeamMatesList.forEach(function (obj) {
        rea_ids.push(obj.user_id);
      });
      selectedFiltersById?.selectedManagerCoachList.forEach(function (obj) {
        manager_ids.push(obj.id);
      });
      selectedFiltersById?.selectedCourseList.forEach(function (obj) {
        lp_ids.push(obj.id);
      });

      if (_.isArray(selectedFiltersById.selectedAgentStatus)) {
        if (selectedFiltersById.selectedAgentStatus.includes(3) ||
          (selectedFiltersById.selectedAgentStatus.includes(1) && selectedFiltersById.selectedAgentStatus.includes(2))
        ) {
          userStatus = 3
        } else if (selectedFiltersById.selectedAgentStatus.includes(1)) {
          userStatus = 1
        } else if (selectedFiltersById.selectedAgentStatus.includes(2)) {
          userStatus = 2
        }
      }

      dispatch(
        getLpTable({
          module: "getlPReportTable",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            status: selectedFiltersById.selectedStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
            is_onboarding: selectedFiltersById.check ? 1 : 0,
            manager_ids: selectedFiltersById.selectedManagerCoachList.map((m) => _.toNumber(m.id)),
            date_range: selectedFiltersById.dateRange,
            office_ids: selectedFiltersById.selectedOfficeList.map((o) => _.toNumber(o.office_id)),
            rea_ids: selectedFiltersById.selectedTeamMatesList.map((r) => _.toNumber(r.user_id)),
            entity_id: selectedFiltersById.selectedTeamMatesList.map((e) => _.toNumber(e.id)),
            role: selectedFiltersById.selectedRole,
            brokerage: selectedFiltersById.selectedBrokerageList,
            user_status: userStatus,
          },
        })
      );

      dispatch(
        getLpOffices({
          module: "getlPReportOffices",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            office_ids: office_ids,
            rea_ids: rea_ids,
            limit: 1,
            entity_id: lp_ids,
            is_onboarding: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
            role: selectedFiltersById.selectedRole,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
          },
        })
      );

      dispatch(
        getLpManagers({
          module: "getlPReportManagers",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            limit: 1,
            office_ids: office_ids,
            rea_ids: rea_ids,
            entity_id: lp_ids,
            is_onboarding: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            status: selectedFiltersById.selectedStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
            role: selectedFiltersById.selectedRole,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
          },
        })
      );

      dispatch(
        getLpRea({
          module: "getlPReportRea",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: rea_ids,
            limit: 1,
            status: selectedFiltersById.selectedStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
            is_onboarding: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            office_ids: office_ids,
            entity_id: lp_ids,
            role: selectedFiltersById.selectedRole,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
          },
        })
      );

      setTrendLoaderChart(true);
      // dispatch(
      //   getLpTrend({
      //     module: "getlPReportTrend",
      //     postData: {
      //       token: isMobile
      //         ? localStorage.getItem(SessionKeys.API_TOKEN)
      //         : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //       office_ids: office_ids,
      //       rea_ids: rea_ids,
      //       status: selectedFiltersById.selectedStatus,
      //       is_onboarding: selectedFiltersById.check ? 1 : 0,
      //       manager_ids: manager_ids,
      //       date_range: selectedFiltersById.dateRange,
      //       entity_id: lp_ids,
      //       year: _.toNumber(trendYear),
      //       role: selectedFiltersById.selectedRole,
      //     },
      //   })
      // );

      // getSingleCompletionTrend(lp_ids);

      dispatch(
        getLpStats({
          module: "getlPReportStats",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            status: selectedFiltersById.selectedStatus,
            assigner_role: selectedFiltersById.selectedAssignment,
            is_onboarding: selectedFiltersById.check ? 1 : 0,
            manager_ids: manager_ids,
            date_range: selectedFiltersById.dateRange,
            office_ids: office_ids,
            rea_ids: rea_ids,
            entity_id: lp_ids,
            role: selectedFiltersById.selectedRole,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus,
          },
        })
      );
    }
  }, [savedFiltersDataById]);


  useEffect(() => {
    console.log("isCompliance: ", isCompliance);
    if (isCompliance === "0") {
      setCheck(false);
    }
  }, [isCompliance]);

  useEffect(() => {
    if (pageNum && !isTableLoading) {
      setIsLoading(true)
      setIsTableLoading(true)
      fetchLPTableReport()
    }
  }, [pageNum, pageSize, progressSort, searchInput])

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    if (!_.isEmpty(localFilters) && localStorage.getItem("SELECTED_FILTER")) {
      removeSelectedFilterFromLocalStorage();
    }
  }, [localFilters])

  useEffect(() => {
    console.log("selectedFilters: ", selectedFilters);
    setIsLoading(true);
    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if ((authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) && false) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters.selectedOfficeList.length == 0) {
            // alert('office requried');
            setIsLoading(false);
            setConfirmModal(true)
          } else {
            setPageNum(0)
            setCounter(1);
            setProgressSort('asc');
            setSearchInput('')
            let userStatus = 4;
            if (_.isArray(selectedFilters.selectedAgentStatus)) {
              if (selectedFilters.selectedAgentStatus.includes(3) ||
                (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
              ) {
                userStatus = 3
              } else if (selectedFilters.selectedAgentStatus.includes(1)) {
                userStatus = 1
              } else if (selectedFilters.selectedAgentStatus.includes(2)) {
                userStatus = 2
              }
            }
            setUserStatusFilter(userStatus)
            setCounterForOffice(1)
            setCounterForMng(1)
            setSelectedValue();
            hitAllFilterApi(userStatus, 1, "", 'asc');
            setCanShow(true);
            removeSelectedFilterFromLocalStorage();
          }
        } else {
          setIsLoading(false)
          setOverAllLearningPoints({
            total_percentage: 0,
            total_assigned: 0,
            total_completed: 0,
            from_last_week_completion_progress: 0
          })
          setOverAllOfficesData([])
          setTotalOffices(0)
          setTotalManagers(0)
          setOverAllManagersData([])
          setTotalRea({
            total_rea: 0
          })
          setRealEstateAgent([])
          setProfileReports([])
        }
      } else if (
        (!_.isEmpty(selectedFilters) && !filterId && !localStorage.getItem("SELECTED_FILTER")) ||
        selectedFilters?.clickedApply
      ) {
        setPageNum(0)
        setCounter(1);
        setProgressSort('asc');
        setSearchInput('')
        let userStatus = 4;
        if (_.isArray(selectedFilters.selectedAgentStatus)) {
          if (selectedFilters.selectedAgentStatus.includes(3) ||
            (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
          ) {
            userStatus = 3
          } else if (selectedFilters.selectedAgentStatus.includes(1)) {
            userStatus = 1
          } else if (selectedFilters.selectedAgentStatus.includes(2)) {
            userStatus = 2
          }
        }
        setUserStatusFilter(userStatus)
        setCounterForOffice(1)
        setCounterForMng(1)
        setSelectedValue();
        hitAllFilterApi(userStatus, 1, "", 'asc');
        setCanShow(true);
        removeSelectedFilterFromLocalStorage();
      } else if (localStorage.getItem("SELECTED_FILTER")) {
        console.log(
          "selected filters----",
          JSON.parse(localStorage.getItem("SELECTED_FILTER"))
        );
        const filterData = JSON.parse(localStorage.getItem("SELECTED_FILTER"))
        if (filterData.isLP) {
          setSelectedFilters(filterData.selectedFilters);
          setLocalFilters(filterData.selectedFilters)
          setIsExpand(true)
        } else {
          setCounter(1);
          let userStatus = 4;
          if (_.isArray(selectedFilters.selectedAgentStatus)) {
            if (selectedFilters.selectedAgentStatus.includes(3) ||
              (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
            ) {
              userStatus = 3
            } else if (selectedFilters.selectedAgentStatus.includes(1)) {
              userStatus = 1
            } else if (selectedFilters.selectedAgentStatus.includes(2)) {
              userStatus = 2
            }
          }
          setUserStatusFilter(userStatus)
          setCounterForOffice(1)
          setCounterForMng(1)
          setSelectedValue();
          hitAllFilterApi(userStatus);
          setCanShow(true);
          removeSelectedFilterFromLocalStorage();
        }
        // setTimeout(() => {
        //   localStorage.removeItem('SELECTED_FILTER')
        // }, 1000)
      }
    }
  }, [selectedFilters, authBroker, authIframeBroker]);

  const removeSelectedFilterFromLocalStorage = () => {
    localStorage.removeItem('SELECTED_FILTER')
  }

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      })
    );
  };

  // const [selectedOfficeList,] = useState(
  //   location?.state?.selectedOfficeList
  // );
  // const [selectedRea,] = useState(
  //   location?.state?.selectedTeamMatesList
  // );
  // const [selectedLpList,] = useState(
  //   location?.state?.selectedLpList
  // );



  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }
  function setCountForOffice(counter, setCounterForOffice) {
    return setCounterForOffice(counter + 1);
  }

  function setCountForManager(counter, setCounterForMng) {
    return setCounterForMng(counter + 1);
  }

  // useEffect(() => {
  //   console.log("selected filters----test", selectedFilters);
  //   if (_.isEqual(selectedFilters, initSelectedFilters)) {
  //   } else {
  //     localStorage.setItem("SELECTED_FILTER", JSON.stringify(selectedFilters));
  //   }
  // }, [selectedFilters]);
  // useEffect(() => {
  //   if (localStorage.getItem("SELECTED_FILTER")) {
  //     console.log(
  //       "selected filters----",
  //       JSON.parse(localStorage.getItem("SELECTED_FILTER"))
  //     );
  //     setSelectedFilters(JSON.parse(localStorage.getItem("SELECTED_FILTER")));
  //   }
  // }, []);

  const setSelectedValue = () => {
    selectedFilters?.selectedOfficeList.forEach(function (obj) {
      office_ids.push(obj.office_id);
    });
    selectedFilters?.selectedTeamMatesList.forEach(function (obj) {
      rea_ids.push(obj.user_id);
    });
    selectedFilters.selectedManagerCoachList.forEach(function (obj) {
      manager_ids.push(obj.id);
    });
    selectedFilters?.selectedCourseList.forEach(function (obj) {
      lp_ids.push(obj.id);
    });
  };

  const hitAllFilterApi = (userStatus = 3, page = 0, searchTerm = "", progressSort = 'asc') => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    setUserStatusFilter(userStatus)

    fetchLPTableReport(page, searchTerm, progressSort, userStatus)
    hitManagerListApi(1, userStatus);
    hitOfficeListApi(1, userStatus);
    hitReaListApi(1, userStatus);

    // hitTrendApi();
    // getSingleCompletionTrend(lp_ids);

    dispatch(
      getLpStats({
        module: "getlPReportStats",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          office_ids: office_ids,
          rea_ids: rea_ids,
          entity_id: lp_ids,
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus
        },
      })
    );
  };

  const fetchLPTableReport = (page = 0, searchTerm = "", sort = '', userStatus = 0) => {

    dispatch(
      getLpTable({
        module: "getlPReportTable",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: selectedFilters.selectedManagerCoachList.map((m) => _.toNumber(m.id)),
          date_range: selectedFilters.dateRange,
          office_ids: selectedFilters.selectedOfficeList.map((o) => _.toNumber(o.office_id)),
          rea_ids: selectedFilters.selectedTeamMatesList.map((r) => _.toNumber(r.user_id)),
          entity_id: selectedFilters.selectedCourseList.map((e) => _.toNumber(e.id)),
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus ? userStatus : userStatusFilter,
          page: page ? page : pageNum ? pageNum : 1,
          page_size: pageSize,
          sortBy: sort ? sort : progressSort ? progressSort : 'asc',
          search: searchTerm ? searchTerm : searchInput ? searchInput : "",
          fetchDetail: false,
        },
      })
    );
    setTimeout(() => {
      console.log('PG NUMBER', page ? page : pageNum ? pageNum : 1)
      dispatch(
        getLpTableDetail({
          module: "getlPReportTable",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            status: selectedFilters.selectedStatus,
            assigner_role: selectedFilters.selectedAssignment,
            is_onboarding: selectedFilters.check ? 1 : 0,
            manager_ids: selectedFilters.selectedManagerCoachList.map((m) => _.toNumber(m.id)),
            date_range: selectedFilters.dateRange,
            office_ids: selectedFilters.selectedOfficeList.map((o) => _.toNumber(o.office_id)),
            rea_ids: selectedFilters.selectedTeamMatesList.map((r) => _.toNumber(r.user_id)),
            entity_id: selectedFilters.selectedCourseList.map((e) => _.toNumber(e.id)),
            role: selectedFilters.selectedRole,
            brokerage: selectedFilters.selectedBrokerageList,
            user_status: userStatus ? userStatus : userStatusFilter,
            page: page ? page : pageNum ? pageNum : 1,
            page_size: pageSize,
            sortBy: sort ? sort : progressSort ? progressSort : 'asc',
            search: searchTerm ? searchTerm : searchInput ? searchInput : "",
            fetchDetail: true
          },
        })
      );
    }, 4000)
  }

  const hitReaListApi = (counter, userStatus = 3) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    dispatch(
      getLpRea({
        module: "getlPReportRea",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: rea_ids,
          limit: counter,
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          office_ids: office_ids,
          entity_id: lp_ids,
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
        },
      })
    );
  };

  const hitOfficeListApi = (counterForOffice, userStatus = 3) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    dispatch(
      getLpOffices({
        module: "getlPReportOffices",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: office_ids,
          rea_ids: rea_ids,
          limit: counterForOffice,
          entity_id: lp_ids,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
        },
      })
    );
  };

  const hitManagerListApi = (counterForMng, userStatus = 3) => {
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) && selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2
      }
    }
    dispatch(
      getLpManagers({
        module: "getlPReportManagers",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: counterForMng,
          office_ids: office_ids,
          rea_ids: rea_ids,
          entity_id: lp_ids,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
        },
      })
    );
  };

  const hitTrendApi = (userStatus = 3) => {
    setTrendLoaderChart(true);
    dispatch(
      getLpTrend({
        module: "getlPReportTrend",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: office_ids,
          rea_ids: rea_ids,
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          entity_id: lp_ids,
          year: _.toNumber(trendYear),
          role: selectedFilters.selectedRole,
          brokerage: selectedFilters.selectedBrokerageList,
          user_status: userStatus,
        },
      })
    );
  };

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply) &&
      (!localStorage.getItem("SELECTED_FILTER") &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true)
    ) {
      // alert('CALL REA');
      setSelectedValue();
      hitReaListApi(counter);
    }
    // setFilterBy(FILTER_BY[0].value);
  }, [dispatch, counter]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply) &&
      (!localStorage.getItem("SELECTED_FILTER") &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true)
    ) {
      setSelectedValue();
      hitOfficeListApi(counterForOffice);
    }
  }, [counterForOffice, authBroker]);

  useEffect(() => {
    if ((!filterId || selectedFilters?.clickedApply) &&
      (!localStorage.getItem("SELECTED_FILTER") &&
      (authBroker.payload?.user || authIframeBroker.payload?.user) &&
      !(authBroker.payload?.user?.is_corporate || authIframeBroker.payload?.user?.is_corporate) || true)
    ) {
      setSelectedValue();
      hitManagerListApi(counterForMng);
    }
  }, [counterForMng]);

  useEffect(() => {
    setCounter(1);
    setRealEstateAgent([]);
    return () => {
      dispatch(getLpReaClear());
    };
  }, []);

  // useEffect(() => {
  //   if (!filterId || selectedFilters?.clickedApply) {
  //     hitTrendApi();
  //   }
  // }, [dispatch, trendYear]);

  const getSingleCompletionTrend = (lp_ids) => {
    setIsLoading(true);
    setLoaderChart(true);
    dispatch(
      getLpTrendSingle({
        module: "getlPReportTrend",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: office_ids,
          rea_ids: rea_ids,
          status: selectedFilters.selectedStatus,
          assigner_role: selectedFilters.selectedAssignment,
          is_onboarding: selectedFilters.check ? 1 : 0,
          manager_ids: manager_ids,
          date_range: selectedFilters.dateRange,
          entity_id: lp_ids,
          role: selectedFilters.selectedRole,
        },
      })
    );
  };

  //LP Table
  useEffect(() => {
    if (!_.isEmpty(lpTableRes)) {
      setIsLoaded(false);
      if (lpTableRes?.status === "success") {
        if (!_.isEmpty(lpTableRes.payload.payload)) {
          const reportData = lpTableRes?.payload?.payload.user_data;
          // setPageNum(reportData.current_page)
          setIsLoading(false);
          setIsTableLoading(false)
          let legends = [];
          let series = [];
          // if (_.isEmpty(reportData)) {
          //   setIsTableLoading(false);
          // }
          setProfileReports(lpTableRes?.payload?.payload);

          setProfileReportsFilter(reportData);
          if (statusFilterData.includes("completed")) {
            let completedCount = reportData.filter(
              (data) => data.status === "completed"
            ).length;
            series.push(
              reportData.filter((data) => data.status === "completed").length
            );
            legends.push(`Completed (${completedCount})`);
          }
          if (statusFilterData.includes("in-progress")) {
            let inprogressCount = reportData.filter(
              (data) => data.status === "in-progress"
            ).length;
            series.push(
              reportData.filter((data) => data.status === "in-progress").length
            );
            legends.push(`In Progress(${inprogressCount})`);
          }
          if (statusFilterData.includes("overdue")) {
            let overdueCount = reportData.filter(
              (data) => data.status === "overdue"
            ).length;
            series.push(
              reportData.filter((data) => data.status === "overdue").length
            );
            legends.push(`Overdue(${overdueCount})`);
          }
          if (statusFilterData.includes("not-started")) {
            let notStartedCount = reportData.filter(
              (data) => data.status === "not-started"
            ).length;
            series.push(
              reportData.filter((data) => data.status === "not-started").length
            );
            legends.push(`Yet to start (${notStartedCount})`);
          }
          if (legends.length < 4) {
            legends.push("Others");
            series.push(totalRecord - _.sum(series));
          }
          setLegends(legends);
          setSeries(series);
          setCurrentPage(1);
          setCanShow(false);
        } else {
          setProfileReports([]);
          setCanShow(false);
          setIsLoading(false);
          setIsTableLoading(false);
        }
      } else {
        setProfileReports([]);
        setCanShow(false);
        setIsLoading(false);
        setIsTableLoading(false);
      }

      dispatch(getLpTableClear());
    }
  }, [lpTableRes]);
  useEffect(() => {
    dispatch(getLpStatsClear());
  }, [dispatch]);
  //LP Rea
  useEffect(() => {
    if (!_.isEmpty(lpReaResponse)) {
      setLoadSpin(false);
      if (lpReaResponse?.status === "success") {
        let allData = [];
        allData = sortByAlphabetical(
          lpReaResponse?.payload?.payload?.real_estate_agents
        );
        // let realEstateAgents = lpReaRes?.payload?.payload?.real_estate_agents;
        setTotalRea(lpReaResponse?.payload?.payload);
        let temparr = _.cloneDeep(realEstateAgent);
        if (counter === 1) {
          temparr = [];
        }
        setReaList([...temparr, ...allData]);
        setLimitStatus(lpReaResponse?.payload?.payload?.real_estate_agents);
        setRealEstateAgent(_.sortBy([...temparr, ...allData], "uid"));
        setActualCoursesList([...temparr, ...allData]);
        dispatch(getLpReaClear());
      }
    }
  }, [lpReaResponse]);

  useEffect(() => {
    // setCrsCompltTrendValues([])
    return () => {
      dispatch(getLpTrendClear());
    };
  }, []);
  //LP Completion trend
  useEffect(() => {
    if (!_.isEmpty(lpTrendRes)) {
      if (lpTrendRes?.status === "success") {
        setImgLoader(false);
        setLoaderChart(false);
        setTrendLoaderChart(false);
        let allData = [];
        allData = lpTrendRes?.payload?.payload?.completion_trend;
        let trendData = Object.entries(allData); //Object.values(allData)
        let tempArrTrend = [["", "Percentage"]];

        for (const [key, value] of trendData) {
          tempArrTrend.push([key, value]);
        }
        setCrsCompltTrendValues(tempArrTrend);

        // setCrsCompltTrendValues(Object.values(allData));
        setFilterYearData(lpTrendRes?.payload?.payload?.year);
        setTrendFilterCourses(lpTrendRes?.payload?.payload?.learningPath);

        let tempArr = [];
        let tempArrSeries = [];
        let legend = lpTrendRes?.payload?.payload?.legends_data;
        tempArr.push(`Completed (${legend?.completed})`);
        tempArrSeries.push(legend?.completed);
        tempArr.push(`In Progress(${legend?.inprogress})`);
        tempArrSeries.push(legend?.inprogress);
        tempArr.push(`Overdue(${legend?.overdue})`);
        tempArrSeries.push(legend?.overdue);
        tempArr.push(`Yet to start (${legend?.notstarted})`);
        tempArrSeries.push(legend?.notstarted);
        setLegendOfAll(tempArr);
        console.log("tempArrSeries", tempArrSeries);
        setSeriesOfAll(tempArrSeries);

        dispatch(getLpTrendClear());
      }
    }
  }, [lpTrendRes]);

  useEffect(() => {
    if (!_.isEmpty(lpTrendResSingle)) {
      setImgLoader(false);
      setIsLoading(false);
      setLoaderChart(false);
      if (lpTrendResSingle?.status === "success") {
        let allData = [];
        allData = lpTrendResSingle?.payload?.payload?.completion_trend;
        let trendData = Object.entries(allData); //Object.values(allData)
        let tempArrTrend = [["", "Percentage"]];

        for (const [key, value] of trendData) {
          tempArrTrend.push([key, value]);
        }
        // setCrsCompltTrendValuesOfSingle(tempArrTrend)
        let seriesSingle = Object.values(allData);
        // if (Number(selectedYear) === (new Date().getFullYear())) {
        let tempSeries = [];
        for (let i = 0; i < seriesSingle.length; i++) {
          const element = seriesSingle[i];
          if (i <= new Date().getMonth()) {
            tempSeries.push(element);
          } else {
            tempSeries.push(null);
          }
        }
        // }
        setCrsCompltTrendValuesOfSingle(tempSeries);
        setFilterYearDataOfSingle(lpTrendResSingle?.payload?.payload?.year);

        let tempArr = [];
        let tempArrSeries = [];
        let legend = lpTrendResSingle?.payload?.payload?.legends_data;
        tempArr.push(`Completed (${legend?.completed})`);
        tempArrSeries.push(legend?.completed);
        tempArr.push(`In Progress(${legend?.inprogress})`);
        tempArrSeries.push(legend?.inprogress);
        tempArr.push(`Overdue(${legend?.overdue})`);
        tempArrSeries.push(legend?.overdue);
        tempArr.push(`Yet to start (${legend?.notstarted})`);
        tempArrSeries.push(legend?.notstarted);

        setLegendOfSingle(tempArr);
        setSeriesOfSingle(tempArrSeries);
        dispatch(getLpTrendClearSingle());
      }
    }
  }, [lpTrendResSingle]);

  //LP Stats
  useEffect(() => {
    if (!_.isEmpty(lpStatsRes)) {
      if (lpStatsRes?.status === "success") {
        setIsLoaded(false);
        let allData = lpStatsRes?.payload?.payload?.stats;
        setOverAllLearningPoints(allData);
      }
      dispatch(getLpStatsClear());
    }
  }, [lpStatsRes]);

  const currentTableData = useMemo(() => {
    console.log("PROFILE REPORTS", profileReports);
    if (!_.isEmpty(profileReports)) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      // setCanShow(true);
      //setIsTableLoading(true);
      return profileReports.user_data.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, profileReports]);
  // let min = Math.ceil(overAllLearningPoints?.learning_mins * 60);
  // filtration
  const sortByAlphabetical = (list) => {
    return list.sort((a, b) => b.learning_points - a.learning_points);
  };
  const sortByProgress = (list) => {
    return list.sort(
      (a, b) =>
        _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
    );
  };
  const sortByLearningHrs = (list) => {
    return list.sort(
      (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
    );
  };
  //REA SECTION
  const onClickFilterBy = (e) => {
    setFilterBy(e.target.value);
    if (e.target.value === "Learning Points") {
      const sortedList = sortByAlphabetical(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (e.target.value === "Progress") {
      const sortedList = sortByProgress(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (e.target.value === "Learning Hours") {
      const sortedList = sortByLearningHrs(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else {
      setRealEstateAgent(reaList);
    }
  };

  // useEffect(() => {
  //   if (counter > 1)
  //     sortAfterLoadMore();
  // }, [actualCoursesList])

  const sortAfterLoadMore = () => {
    if (filterBy === "Learning Points") {
      const sortedList = sortByAlphabetical(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (filterBy === "Progress") {
      const sortedList = sortByProgress(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (filterBy === "Learning Hours") {
      const sortedList = sortByLearningHrs(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else {
      setRealEstateAgent(reaList);
    }
  };

  const ExportToExcel = async () => {
    setIsLoading(true)
    await axios.post(
      `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.BROKER_API.LEARNING_PATH_TABLE}`,
      {
        token: isMobile
          ? localStorage.getItem(SessionKeys.API_TOKEN)
          : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        status: selectedFilters.selectedStatus,
        assigner_role: selectedFilters.selectedAssignment,
        is_onboarding: selectedFilters.check ? 1 : 0,
        manager_ids: selectedFilters.selectedManagerCoachList.map((m) => _.toNumber(m.id)),
        date_range: selectedFilters.dateRange,
        office_ids: selectedFilters.selectedOfficeList.map((o) => _.toNumber(o.office_id)),
        rea_ids: selectedFilters.selectedTeamMatesList.map((r) => _.toNumber(r.user_id)),
        entity_id: selectedFilters.selectedCourseList.map((e) => _.toNumber(e.id)),
        role: selectedFilters.selectedRole,
        user_status: userStatusFilter,
        sortBy: 'asc',
        search: searchInput ? searchInput : "",
        brokerage: selectedFilters.selectedBrokerageList,
        fetchDetail: false,
        isDownload: true
      },
      { header: { "Content-Type": "application/json" } }
    )
      .then((response) => {
        if (response.data?.status) {
          const userRecords = response.data?.data?.user_data;
          if (!_.isEmpty(userRecords)) {
            // const data = _.cloneDeep(profileReports.user_data);
            const data = _.cloneDeep(userRecords);
            console.log(data);
            for (let item of data) {
              item.profile_status =
                (item?.profile_status === "Inprogress" || item?.profile_status === "in-progress")
                  ? "In Progress"
                  : item?.profile_status === "Yet to start" ||
                    item?.profile_status === "not-started"
                    ? "Yet to start"
                    : (item?.profile_status === "OverDue" || item?.profile_status === "over-due")
                      ? "Overdue"
                      : "Completed";
              item.profile_progress =
                item?.profile_progress !== undefined && item?.profile_progress !== ""
                  ? item?.profile_progress + "%"
                  : "-";
              item.complete_date =
                item?.complete_date !== undefined && item?.complete_date !== ""
                  ? moment(
                    StaticUtils.getDateFromTimeStamp(item?.complete_date),
                    "MM/DD/YYYY"
                  ).format("DD MMM, YYYY")
                  : "-";
            }

            //for sequencing
            let tempArr = [];
            for (const item of data) {
              let obj = {
                name: item?.first_name + " " + item?.last_name,
                // "last_name": item.last_name,
                role: item.roles,
                email: item.email,
                office_name: item.office_name,
                user_manager_name: item.user_manager_name,
                ofc_location: item.ofc_location,

                user_status: item.user_status ? "Active" : "In Active",
                lp_name: item.lp_name,
                profile_status: item.profile_status,
                profile_progress: item.profile_progress,
                complete_date: item.complete_date,
              };
              tempArr.push(obj);
            }

            const newThing = [];
            tempArr.map((item) => {
              newThing.push(
                _.mapKeys(item, (value, key) => {
                  switch (key) {
                    case "name":
                      return "Name";
                    // case "last_name":
                    //     return "Last Name";
                    case "role":
                      return "Role";
                    case "email":
                      return "Email";
                    case "office_name":
                      return officeLabel;
                    case "user_manager_name":
                      return "Manager";
                    case "user_status":
                      return "User Status";
                    case "lp_name":
                      return selectedFilters.check
                        ? "Onboarding Learning Path"
                        : "Learning Path";
                    case "profile_status":
                      return "Status";
                    case "profile_progress":
                      return "Progress %";
                    default:
                      return;
                  }
                })
              );
            });

            for (let i = 0; i < newThing.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete newThing[i].undefined;
            }

            for (let i = 0; i < data.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete data[i]._id;
            }
            // console.log('data:', data)
            // exportFromJSON({ data, fileName, exportType })

            //For mobile
            let tempObj = {
              method: selectedFilters.check
                ? "Onboarding_Report"
                : "Learning_Path_Report",
              report: newThing,
            };
            if (window.callbackHandler != undefined) {
              window.callbackHandler.postMessage(JSON.stringify(tempObj));
            } else if (window.webkit != undefined) {
              if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                  JSON.stringify(tempObj)
                );
              }
            }

            const worksheet = XLSX.utils.json_to_sheet(newThing);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
            //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            let fileNameNew = selectedFilters?.check ? "Onboarding" : "Learning Path";
            XLSX.writeFile(workbook, fileNameNew + ".xlsx");
            setIsLoading(false)
          }
        }
      })

      .finally(res => {
        setIsLoading(false)
      })
  };

  //LP Managers
  useEffect(() => {
    if (!_.isEmpty(lpManagersRes)) {
      setLoadSpining(false);
      if (lpManagersRes?.status === "success") {
        let allData = lpManagersRes?.payload?.payload?.managers;
        setTotalManagers(lpManagersRes?.payload?.payload);
        let temparr = _.cloneDeep(overAllManagersData);
        if (counterForMng === 1) {
          temparr = [];
        }
        setOverAllManagersData([...temparr, ...allData]);
        dispatch(getLpManagersClear());
      }
    }
  }, [lpManagersRes]);

  useEffect(() => {
    if (!_.isEmpty(lpOfficesRes)) {
      setLoadSpinner(false);
      if (lpOfficesRes?.status === "success") {
        let allData = lpOfficesRes?.payload?.payload?.offices;
        setTotalOffices(lpOfficesRes?.payload?.payload);
        let temparr = _.cloneDeep(overAllOfficesData);
        if (counterForOffice === 1) {
          temparr = [];
        }
        setOverAllOfficesData([...temparr, ...allData]);
        dispatch(getLpOfficesClear());
      }
    }
  }, [lpOfficesRes]);

  const searchTable = (searchVal) => {
    console.log("searchedval", searchVal);
    let list = _.cloneDeep(profileReportsFilter);
    if (searchVal === "") {
      setProfileReports(list);
      return;
    }

    let filterBySearch = [];
    for (const item of list) {
      let user_status = "";
      if (item?.user_status) {
        user_status = "active";
      }
      else {
        user_status = "in active";
      }
      if (
        item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.full_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.lp_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.user_manager_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        user_status.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);

    setProfileReports(filterBySearch);
    // setCanShow(false);
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header pt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn"
                  onClick={() => {
                    dispatch(
                      getLpReaClear(),
                      getLpStatsClear(),
                      getLpTrendClear(),
                      getSavedFilterDataResponseClearById()
                    );
                    removeSelectedFilterFromLocalStorage();
                    let obj = { message: "backButton" };
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        CONFIG.API_URL_BROKER_ADMIN
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton"
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                  }}
                >
                  Back
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">Reports</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={
                  isCompliance === "0"
                    ? "Learning Path Report"
                    : "Onboarding Report"
                }
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  isLp={true}
                  isMobile={isMobile}
                  showFilters={showFilters}
                  hideOverDueStatus={false}
                  reportType={
                    isCompliance === "0" ? "learning_path" : "onboarding"
                  }
                  setLocalFilters={setLocalFilters}
                  localFilters={localFilters}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <ReportGraphComponent
        trendYear={trendYear}
        loadChart={loaderChart}
        seriesAll={seriesOfAll}
        legendsAll={legendOfAll}
        trendValues={crsCompltTrendValues}
        listingData={lp_ids}
        seriesSingle={seriesOfSingle}
        legendsSingle={legendOfSingle}
        trendLoadChart={trendLoaderChart}
        filterYearData={filterYearData}
        trendFilterCourses={trendFilterCourses}
        overAllLearningPoints={overAllLearningPoints}
        trendValueSingle={crsCompltTrendValuesOfSingle}
        setYear={setTrendYear}
        setLoadChart={setLoaderChart}
        setImgLoader={setImgLoader}
        getCompletionTrend={getSingleCompletionTrend}
        filterYearDataOfSingle={filterYearDataOfSingle}
        isDetail={false}
        check={check}
        isLp={true}
      />

      {/* Offices Section */}
      {false && (
        <OfficeSection
          mesg={
            "The offices of Managers and assigned REA's will be displayed in this section."
          }
          section={"lp"}
          isMobile={isMobile}
          selectedCourseList={selectedFilters.selectedCourseList}
          selectedTeamMatesList={selectedFilters.selectedTeamMatesList}
          selectedOfficeList={selectedFilters.selectedOfficeList}
          check={selectedFilters.check}
          selectedManagerCoachList={selectedFilters.selectedManagerCoachList}
          dateRange={selectedFilters.dateRange}
          statusArr={selectedFilters.selectedStatus}
          isDetail={false}
        // selectedFilters={selectedFilters}
        />
      )}

      <OfficesReportSection
        currentReportObj={"compliance"}
        mesg={
          "The offices of Managers and assigned REA's will be displayed in this section."
        }
        isMobile={isMobile}
        check={selectedFilters.check}
        overAllOfficesData={overAllOfficesData}
        setOverAllOfficesData={setOverAllOfficesData}
        setCountForOffice={setCountForOffice}
        setCounterForOffice={setCounterForOffice}
        counterForOffice={counterForOffice}
        totalOffices={totalOffices}
        cmpletionText={"Agents Compliant"}
        isLP={true}
        selectedFilters={selectedFilters}
      />

      {false && (
        <ManagerReportSec
          mesg={
            "The Managers that are assigned for Learning Paths will be shown on this section."
          }
          section={"lp"}
          isMobile={isMobile}
          selectedCourseList={selectedFilters.selectedCourseList}
          selectedTeamMatesList={selectedFilters.selectedTeamMatesList}
          selectedOfficeList={selectedFilters.selectedOfficeList}
          check={selectedFilters.check}
          selectedManagerCoachList={selectedFilters.selectedManagerCoachList}
          dateRange={selectedFilters.dateRange}
          statusArr={selectedFilters.selectedStatus}
          isDetail={false}
        />
      )}

      <ManagerReportCrs
        currentReportObj={"compliance"}
        mesg={
          "The Managers that are assigned for Courses will be shown on this section."
        }
        isMobile={isMobile}
        check={selectedFilters.check}
        isDetail={false}
        totalManagers={totalManagers}
        setTotalManagers={setTotalManagers}
        overAllManagersData={overAllManagersData}
        setOverAllManagersData={setOverAllManagersData}
        setCountForManager={setCountForManager}
        setCounterForMng={setCounterForMng}
        counterForMng={counterForMng}
        cmpletionText={"Learning Paths Completed"}
        isLP={true}
        selectedFilters={selectedFilters}
      />

      <REACardAreaSection
        totalREA={totalRea?.total_rea}
        extraHeader={"- Cumulative Progress of an Agent"}
        realEstateAgent={realEstateAgent}
        isMobile={isMobile}
        actualCoursesList={actualCoursesList}
        setLoadSpin={setLoadSpin}
        loadSpin={loadSpin}
        setCount={setCount}
        counter={counter}
        setCounter={setCounter}
        check={selectedFilters.check}
        cmpletionText={"Learning Paths Completed"}
        isDetail={false}
        isLP={true}
        selectedFilters={selectedFilters}
      />

      {false && (
        <ReportTableSectionComp
          setSearchInput={""}
          getFilteredData={[]}
          lpName={"Learning Path"}
          isLearningPath={true}
          isView={isView}
          statusFilterData={statusFilterData}
          setCanShow={setCanShow}
          profileReports={profileReports}
          currentTableData={currentTableData}
          type={type}
          message={
            "Learning Paths that are assigned to users, will appear here."
          }
        />
      )}
      <div id="myOnboard" className="center_line"></div>
      <ProgressReportTableComponent
        getFilteredData={[]}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        isView={isView}
        statusFilterData={statusFilterData}
        canShow={canShow}
        setCanShow={setCanShow}
        profileReports={profileReports}
        currentTableData={currentTableData}
        type={type}
        message={"Learning Paths that are assigned to users, will appear here."}
        isCompliance={true}
        searchTable={searchTable}
        fromPage={selectedFilters.check ? 3 : 2} // 1=course, 2= Learning Path, 3=Onboarding
        reportType={"learningpath"}
        isMobile={isMobile}
        setPageNum={setPageNum}
        pageNum={pageNum}
        pageSize={pageSize}
        setPageSize={setPageSize}
        progressSort={progressSort}
        setProgressSort={setProgressSort}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        fetchData={fetchLPTableReport}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={
          `${officeLabel == 'Office Name' ? 'Office(s)' : officeLabel} is mandatory, please select first.`
        }
        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};

export default LearningPathReportHomeSection;
